import myAxios from './myAxios';

export default function uploadFile(file, onProgress) {
  const formData = new FormData();
  formData.append('file', file);

  return myAxios.post('/storage/files/', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (e) => {
      onProgress(Math.floor((e.loaded / e.total) * 100));
    },
  });
}
